import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { Customer } from '../../models/customer.model';
import { DeliveryAddress } from '../../models/delivery-address.model';
import { EANCodeType } from '../../models/ean-code-type.model';
import { EANCode } from '../../models/ean-code.model';
import { MeterType } from '../../models/meter-type.model';
import { Permission } from '../../models/permission.model';
import { AccountService } from '../../services/account.service';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { fadeInOut } from '../../services/animations';
import { CustomersService } from '../../services/customers.service';
import { DeliveryAddressService } from '../../services/delivery-address.service';
import { EANCodeTypeService } from '../../services/ean-code-type.service';
import { EANCodeService } from '../../services/ean-code.service';
import { MeterTypeService } from '../../services/meter-type.service';

const _ = require('lodash');

@Component({
    selector: 'delivery-address-add-update',
    template: require('./delivery-address-add-update.component.html'),
    styles: [require('./delivery-address-add-update.component.css')],
    animations: [fadeInOut]
})
export class DeliveryAddressAddUpdateComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];
    disableYearSingleConsumption: boolean = false;
    disableYearPeakConsumption: boolean = false;
    disableYearLowConsumption: boolean = false;
    isEditablePermission: boolean = false;

    mode: string = "Toevoegen";
    deliveryAddress: DeliveryAddress = new DeliveryAddress;
    // yearRange: string = (new Date().getFullYear() - 10) + ':' + new Date().getFullYear();
    meterTypes: MeterType[] = [];
    eanCodeTypes: EANCodeType[] = [];
    alleanCodeTypes: EANCodeType[] = [];
    eanCode: EANCode = new EANCode;
    fCustomer: any;
    companyName: string;
    mindate: Date = new Date();
    maxdate: Date = new Date();
    isGasDetailsArrive: boolean = true;
    isElectricityDetailsArrive: boolean = true;

    constructor(private accountService: AccountService, private customersService: CustomersService, private deliveryAddressService: DeliveryAddressService, private meterTypeService: MeterTypeService, private eanCodeTypeService: EANCodeTypeService, private eanCodeService: EANCodeService,
        private activatedRoute: ActivatedRoute, private alertService: AlertService, private ngxLogger: NGXLogger) {
    }

    ngOnInit(): void {
        if (this.canviewDeliveryAddress) {
            this.isEditablePermission = true;
        }

        if (this.caneditDeliveryAddress) {
            this.isEditablePermission = false;
        }

        if (this.caneditDeliveryAddress && this.canviewDeliveryAddress) {
            this.isEditablePermission = false;
        }

        if (this.canviewDeliveryAddress && this.caneditDeliveryAddress == false) {
            this.isEditablePermission = true;
        }
        this.isEditablePermission = this.canaddDeliveryAddress;

        const meterTypeGetSubscriber = this.meterTypeService.get().subscribe((res: MeterType[]) => {
            this.meterTypes = res;
        });
        this.subscribers.push(meterTypeGetSubscriber);

        const eancodetypeSubscriber = this.eanCodeTypeService.get().subscribe((res: EANCodeType[]) => {
            this.alleanCodeTypes = res;
            this.eanCodeTypes = res;
        });
        this.subscribers.push(eancodetypeSubscriber);

        const cType = this.activatedRoute.snapshot.params["ctype"];
        if (cType) {
            this.deliveryAddress.CType = cType.toUpperCase();
        }

        const cid = this.activatedRoute.snapshot.params["cid"];
        if (cid) {
            this.deliveryAddress.CustomerId = cid;
            const GetCustByIdSubscriber = this.fCustomer = this.customersService.getById(parseInt(cid)).subscribe((res: Customer) => {
                this.companyName = res.Company;
            });
            this.subscribers.push(GetCustByIdSubscriber);
        }

        const id = this.activatedRoute.snapshot.params["id"];
        if (id) {
            this.isEditablePermission = this.caneditDeliveryAddress;
            this.deliveryAddress.Id = id;
            this.eanCode.DeliveryAddressId = id;
            this.mode = "Bewerk";
            this.getById();
        }
        this.maxdate = new Date();
        this.mindate = new Date((this.maxdate.getFullYear() - 10), this.maxdate.getMonth(), this.maxdate.getDay());
    }

    disableGrpYearPeakConsumption(yearSingleConsumption: string) {
        if (yearSingleConsumption != '') {
            this.disableYearPeakConsumption = true;
            this.disableYearLowConsumption = true;
            this.disableYearSingleConsumption = false;
            this.deliveryAddress.E_YearPeakConsumption = null;
            this.deliveryAddress.E_YearLowConsumption = null;
        } else {
            if (this.deliveryAddress.E_YearPeakConsumption == null && this.deliveryAddress.E_YearLowConsumption == null) {
                this.disableYearPeakConsumption = false;
                this.disableYearLowConsumption = false;
                this.disableYearSingleConsumption = false;
                this.deliveryAddress.E_YearSingleConsumption = null;
            } else {
                this.disableYearPeakConsumption = false;
                this.disableYearLowConsumption = false;
                this.disableYearSingleConsumption = true;
                this.deliveryAddress.E_YearSingleConsumption = null;
            }
        }
    }

    disableyearSingleConsumption(val: string, seq: number) {
        if (val != '') {
            this.disableYearSingleConsumption = true;
            if (this.deliveryAddress.E_YearPeakConsumption == null && this.deliveryAddress.E_YearLowConsumption == null) {
                this.deliveryAddress.E_YearSingleConsumption = null;
            }

            if (seq == 1) {
                this.disableYearPeakConsumption = false;
            }

            if (seq == 2) {
                this.disableYearLowConsumption = false;
            }
        } else {
            if (this.deliveryAddress.E_YearSingleConsumption != null) {
                if (seq == 1) {
                    this.deliveryAddress.E_YearPeakConsumption = null;
                }
                if (seq == 2) {
                    this.deliveryAddress.E_YearLowConsumption = null;
                }
                if (this.deliveryAddress.E_YearPeakConsumption == null && this.deliveryAddress.E_YearLowConsumption == null) {
                    this.disableYearSingleConsumption = false;
                    this.disableYearPeakConsumption = true;
                    this.disableYearLowConsumption = true;
                }
            } else {
                if (seq == 1) {
                    this.deliveryAddress.E_YearPeakConsumption = null;
                }
                if (seq == 2) {
                    this.deliveryAddress.E_YearLowConsumption = null;
                }

                if (this.deliveryAddress.E_YearPeakConsumption == null && this.deliveryAddress.E_YearLowConsumption == null) {
                    this.disableYearPeakConsumption = false;
                    this.disableYearLowConsumption = false;
                    this.disableYearSingleConsumption = false;
                    this.deliveryAddress.E_YearPeakConsumption = null;
                    this.deliveryAddress.E_YearLowConsumption = null;
                }
            }
        }
    }

    getById() {
        const dAddressGetByIDSubscriber = this.deliveryAddressService.getDeliveryAddressById(this.deliveryAddress.Id)
            .subscribe((res: DeliveryAddress) => {
                this.deliveryAddress = res;
                this.deliveryAddress.RentedFrom = new Date(this.deliveryAddress.RentedFrom);

                if (this.deliveryAddress.G_MeterTypeId != null && this.deliveryAddress.G_YearConsumption != null) {
                    this.isGasDetailsArrive = true;
                } else {
                    this.isGasDetailsArrive = false;
                }

                if (this.deliveryAddress.E_MeterTypeId != null) {
                    this.isElectricityDetailsArrive = true;
                } else {
                    this.isElectricityDetailsArrive = false;
                }

                if (this.deliveryAddress.E_YearSingleConsumption != null) {
                    this.disableYearPeakConsumption = true;
                    this.disableYearLowConsumption = true;
                } else {
                    this.disableYearPeakConsumption = false;
                    this.disableYearLowConsumption = false;
                }

                if (this.deliveryAddress.E_YearPeakConsumption != null && this.deliveryAddress.E_YearLowConsumption != null) {
                    this.disableYearSingleConsumption = true;
                } else {
                    this.disableYearSingleConsumption = false;
                }

                if (this.isElectricityDetailsArrive == false) {
                    this.eanCodeTypes = this.alleanCodeTypes.filter(c => c.Name == 'Afname Gas');
                }

                if (this.isGasDetailsArrive == false) {
                    this.eanCodeTypes = this.alleanCodeTypes.filter(c => c.Name != 'Afname Gas');
                }

                if (this.isElectricityDetailsArrive == true && this.isGasDetailsArrive == true) {
                    this.eanCodeTypes = this.alleanCodeTypes;
                }
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
        this.subscribers.push(dAddressGetByIDSubscriber);
    }

    createUpdate() {
        if (((this.deliveryAddress.G_YearConsumption != null || this.deliveryAddress.G_YearConsumption != undefined)) && (this.deliveryAddress.G_MeterTypeId != null || this.deliveryAddress.G_MeterTypeId != undefined)) {
            this.isGasDetailsArrive = true;
        } else {
            this.isGasDetailsArrive = false;
        }

        if ((this.deliveryAddress.E_MeterTypeId != null || this.deliveryAddress.E_MeterTypeId != undefined) && (this.deliveryAddress.E_YearSingleConsumption != null || (this.deliveryAddress.E_YearPeakConsumption && this.deliveryAddress.E_YearLowConsumption))) {
            this.isElectricityDetailsArrive = true;
        } else {
            this.isElectricityDetailsArrive = false;
        }

        if (this.isGasDetailsArrive == false && this.isElectricityDetailsArrive == false) {
            this.alertService.showMessage('Verplicht', 'Elektriciteit of gas is vereist!', MessageSeverity.error);
        }

        if (this.isGasDetailsArrive == true || this.isElectricityDetailsArrive == true) {

            if (this.isEditablePermission) {
                this.deliveryAddress.Customer = null;
                this.deliveryAddress.E_MeterType = null;
                this.deliveryAddress.G_MeterType = null;
                this.deliveryAddress.ContractBaseDeliveryAddresses = [];

                // if (this.deliveryAddress.E_YearSingleConsumption || (this.deliveryAddress.E_YearPeakConsumption && this.deliveryAddress.E_YearLowConsumption)) {
                const cuSubscriber = this.deliveryAddressService.createUpdate(this.deliveryAddress).subscribe((res: DeliveryAddress) => {
                    if (res) {
                        this.deliveryAddress = res;
                        this.alertService.showMessage('Leveringsadres', 'Veranderingen succesvol opgeslagen!', MessageSeverity.success);

                        if (this.isElectricityDetailsArrive == false) {
                            this.eanCodeTypes = this.alleanCodeTypes.filter(c => c.Name == 'Afname Gas');
                        }

                        if (this.isGasDetailsArrive == false) {
                            this.eanCodeTypes = this.alleanCodeTypes.filter(c => c.Name != 'Afname Gas');
                        }

                        if (this.isElectricityDetailsArrive == true && this.isGasDetailsArrive == true) {
                            this.eanCodeTypes = this.alleanCodeTypes;
                        }

                        // NOTE: STOPPED NAVIGATION AS PER REQUEST FROM KRIS
                        // this.router.navigate(['/customer/edit', res.CustomerId]);
                    }
                }, error => {
                    this.ngxLogger.error(error.message);
                    throw error;
                });
                this.subscribers.push(cuSubscriber);
                //} else {
                //    this.alertService.showMessage("Leveringsadres", "Er is jaarlijks verbruik of Piek/Dal verbruik verplicht", MessageSeverity.error);
                //}
            }
        }
    }

    addEANCode() {
        if (!this.eanCode.EANNumber || !this.eanCode.EANCodeTypeId) {
            this.alertService.showMessage("EAN Code", "Zowel EAN-nummer als EAN-codetype zijn vereist", MessageSeverity.warn);
            return false;
        }

        if (this.deliveryAddress.EanCodes != null && this.deliveryAddress.EanCodes.length > 0) {

            if (this.deliveryAddress.EanCodes.filter(c => c.EANNumber == this.eanCode.EANNumber && c.EANCodeTypeId == this.eanCode.EANCodeTypeId).length > 0) {
                this.alertService.showMessage("EAN Code", "Zowel EAN - nummer als EAN - codetype moet uniek zijn.", MessageSeverity.warn);
                return false;
            }
        }

        this.deliveryAddress.EanCodes.push(Object.assign({}, this.eanCode));
        this.deliveryAddress.EanCodes = this.deliveryAddress.EanCodes.slice();

        this.eanCode = Object.assign({}, new EANCode());
        this.eanCode.DeliveryAddressId = this.deliveryAddress.Id;
    }

    getEANCodeTypeNameById(id: number) {
        const selectedEanCodeType: EANCodeType = _.filter(this.alleanCodeTypes, function (o) {
            return o.Id == id;
        });
        if (selectedEanCodeType && selectedEanCodeType !== undefined) {
            return selectedEanCodeType[0].Name;
        }
        return "";
    }

    deleteEANCode(idx: number, eanCode: EANCode) {
        if (eanCode.Id) {
            // Delete from database
            this.alertService.showDialog('Ben je zeker van volgende eancode te verwijderen: ' + eanCode.EANNumber + ' ?', DialogType.confirm, () => {
                const eancodeDelSubscriber = this.eanCodeService.delete(eanCode.Id).subscribe(res => {
                    this.deliveryAddress.EanCodes.splice(idx, 1);
                }, error => {
                    this.ngxLogger.error(error.message);
                    throw error;
                });
                this.subscribers.push(eancodeDelSubscriber);
            });
        } else {
            // Delete from local array
            this.deliveryAddress.EanCodes.splice(idx, 1);
        }
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    get canviewDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.viewDeliveryAddressPermission);
    }

    get canmanageDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.manageDeliveryAddressPermission);
    }

    get canaddDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.addDeliveryAddressPermission);
    }

    get caneditDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.editDeliveryAddressPermission);
    }

    get candeleteDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.deleteDeliveryAddressPermission);
    }

    get canlistDeliveryAddress() {
        return this.accountService.userHasPermission(Permission.listDeliveryAddressPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/delivery-address/delivery-address-add-update.component.ts